import { createSelector } from 'reselect';
import prop from 'ramda/src/prop';

const getPermissionsRootSelector = prop('permissions');

export const getPermissionsSelector = getPermissionsRootSelector;

export const getPermissionSelector = (objectId) => createSelector(getPermissionsSelector, prop(objectId));
